import React from "react";
import svg10 from "../../../assets/svg/svg10.svg";
import { useNavigate } from "react-router-dom";

function PersonalFinances() {
  const navigate = useNavigate();

  const handleLogin = async () => {
    window.location.href = "https://app.impaladigitalpayment.com/#/login";
  };
  return (
    <div className="lg:py-[6rem] py-[3rem] flex items-center justify-center flex-col lg:px-0 px-3">
      <div className="text-ink lg:text-[2.875rem] text-[1.2rem] font-[600] leading-[3.375rem] ">
        Ready to Simplify Your Finances?
      </div>

      <div className="mt-[1.5rem] text-body font-[400] text-[1.125rem] font-interSans leading-[1.75rem]">
        Join thousands of Kenyans using Impala Digital Payments to manage their daily payments
        securely.
      </div>

      <button
        className="cstm-btn-2 lg:mt-[3.25rem] mt-[1rem] !w-[16.75rem]"
        onClick={handleLogin}
      >
        Start Using Impala Digital Payments
        <img src={svg10} alt="svg10" />
      </button>
    </div>
  );
}

export default PersonalFinances;
